import { Utilities } from "@tylertech/shared-module";
import { Expression } from "./abstract.expression";

export class InFunction extends Expression 
{
    constructor(protected field: string, protected value: string[] | number[] | Date[]) 
    {
        super();
    }

    toQuery(): string 
    {
        const params: (string | number | boolean)[] = [];

        for (let i = 0; i < this.value.length; i++) 
        {
            const element = this.value[i];
            const val = Expression.QuoteValueIncludingGuids(element);
            params.push(val);
        }
        const paramString = params.filter(c => !Utilities.IsNullOrUndefined(c)).join(",");

        return `${this.field} in (${paramString})`;
    }
}
